// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tags":"filter-tags__tags--qaI26","tag":"filter-tags__tag--Yb5Jl","value":"filter-tags__value--32kQx","btn":"filter-tags__btn--14csW"};